(() => {
  const DEFAULT_LABELS = {
    tipo: 'Di cosa hai bisogno',
    spazio: 'Quanto spazio hai',
  };
  const HOME_VIDEO_SELECTOR = '[data-rhd-anchor="home-video"]';
  const HOME_VIDEO_IDS = ['1194285556', '1194285557'];
  const FEEDATY_SECTION_SELECTOR = '[id$="__17793674995e9ccdc4"]';
  const FEEDATY_PATCH_DELAYS = [0, 150, 500, 1200];
  let feedatyResizeBound = false;
  let feedatyVisibilityObserver;
  let feedatyMutationObserver;
  let activeFeedatySection = null;

  const cssString = (value) => `"${String(value).replaceAll('\\', '\\\\').replaceAll('"', '\\"')}"`;
  const debounce = (fn, delay = 120) => {
    let timeoutId;

    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  };

  const setFieldLabel = (root, name, label) => {
    const labelNode = root.querySelector(`[data-cf-label="${name}"]`);
    const field = root.querySelector(`[data-cf-dd="${name}"]`);

    if (labelNode) {
      labelNode.textContent = label || DEFAULT_LABELS[name] || '';
    }

    if (field) {
      if (label) {
        field.style.setProperty(`--cf-${name}-label`, cssString(label));
        field.classList.add('is-selected');
      } else {
        field.style.removeProperty(`--cf-${name}-label`);
        field.classList.remove('is-selected');
      }
    }
  };

  const patchHomeVideoIframe = (iframe) => {
    if (!iframe || iframe.dataset.rhdNoUnmute === 'done') return false;

    const src = iframe.getAttribute('src') || '';
    const matchesVideo = HOME_VIDEO_IDS.some((videoId) => src.includes(`player.vimeo.com/video/${videoId}`));
    if (!matchesVideo) return false;

    let url;
    try {
      url = new URL(src, window.location.href);
    } catch (error) {
      return false;
    }

    url.searchParams.set('autoplay', '0');
    url.searchParams.set('muted', '0');
    url.searchParams.set('loop', '1');
    url.searchParams.delete('background');
    url.searchParams.delete('controls');

    iframe.dataset.rhdNoUnmute = 'done';
    iframe.setAttribute('src', url.toString());
    return true;
  };

  const patchHomeVideo = () => {
    const section = document.querySelector(HOME_VIDEO_SELECTOR);
    if (!section) return;

    const applyPatch = () => {
      section
        .querySelectorAll('iframe.js-vimeo[src*="player.vimeo.com/video/"]')
        .forEach(patchHomeVideoIframe);
    };

    applyPatch();

    const observer = new MutationObserver(() => {
      applyPatch();

      if (section.querySelector('iframe.js-vimeo[data-rhd-no-unmute="done"]')) {
        observer.disconnect();
      }
    });

    observer.observe(section, {
      childList: true,
      subtree: true,
    });

    setTimeout(() => observer.disconnect(), 8000);
  };

  const patchFeedatyVerifiedIcon = (section) => {
    section.querySelectorAll('.shopify-feedaty-widget img[src*="checked.svg"]').forEach((image) => {
      image.removeAttribute('width');
      image.removeAttribute('height');
      image.style.setProperty('width', '18px', 'important');
      image.style.setProperty('height', '18px', 'important');
      image.style.setProperty('min-width', '18px', 'important');
      image.style.setProperty('min-height', '18px', 'important');
      image.style.setProperty('max-width', '18px', 'important');
      image.style.setProperty('max-height', '18px', 'important');
      image.style.setProperty('object-fit', 'contain', 'important');
      image.style.setProperty('flex', '0 0 18px', 'important');
    });
  };

  const patchFeedatyDesktopArrows = (section) => {
    if (window.innerWidth < 750) return;

    section.querySelectorAll('.shopify-feedaty-widget .fdt_carousel').forEach((carousel) => {
      carousel.style.setProperty('position', 'relative', 'important');
      carousel.style.setProperty('overflow', 'visible', 'important');
    });

    section.querySelectorAll('.shopify-feedaty-widget .fdt_carousel_controls').forEach((controls) => {
      controls.style.setProperty('display', 'block', 'important');
      controls.style.setProperty('position', 'absolute', 'important');
      controls.style.setProperty('inset', '0', 'important');
      controls.style.setProperty('width', '100%', 'important');
      controls.style.setProperty('z-index', '20', 'important');
      controls.style.setProperty('pointer-events', 'none', 'important');
      controls.style.setProperty('overflow', 'visible', 'important');
    });

    section.querySelectorAll('.shopify-feedaty-widget .carousel_control').forEach((button) => {
      button.style.setProperty('display', 'flex', 'important');
      button.style.setProperty('position', 'absolute', 'important');
      button.style.setProperty('top', '50%', 'important');
      button.style.setProperty('width', '28px', 'important');
      button.style.setProperty('height', '28px', 'important');
      button.style.setProperty('min-width', '28px', 'important');
      button.style.setProperty('min-height', '28px', 'important');
      button.style.setProperty('margin', '0', 'important');
      button.style.setProperty('padding', '0', 'important');
      button.style.setProperty('border', '2px solid #17304d', 'important');
      button.style.setProperty('border-radius', '50%', 'important');
      button.style.setProperty('background', '#fff', 'important');
      button.style.setProperty('background-image', 'none', 'important');
      button.style.setProperty('color', 'transparent', 'important');
      button.style.setProperty('font-size', '0', 'important');
      button.style.setProperty('line-height', '1', 'important');
      button.style.setProperty('text-indent', '0', 'important');
      button.style.setProperty('overflow', 'visible', 'important');
      button.style.setProperty('transform', 'translateY(-50%)', 'important');
      button.style.setProperty('align-items', 'center', 'important');
      button.style.setProperty('justify-content', 'center', 'important');
      button.style.setProperty('opacity', '1', 'important');
      button.style.setProperty('visibility', 'visible', 'important');
      button.style.setProperty('pointer-events', 'auto', 'important');
      button.style.setProperty('z-index', '21', 'important');

      if (button.classList.contains('slide-next')) {
        button.style.setProperty('left', 'auto', 'important');
        button.style.setProperty('right', '6px', 'important');
      }

      if (button.classList.contains('slide-prev')) {
        button.style.setProperty('left', '6px', 'important');
        button.style.setProperty('right', 'auto', 'important');
      }
    });
  };

  const patchFeedatyMobileWidth = (section) => {
    if (window.innerWidth > 749) return;

    section.querySelectorAll('.shopify-feedaty-widget').forEach((widget) => {
      widget.style.setProperty('width', 'calc(100% + 32px)', 'important');
      widget.style.setProperty('max-width', 'none', 'important');
      widget.style.setProperty('margin-left', '-16px', 'important');
      widget.style.setProperty('margin-right', '-16px', 'important');
      widget.style.setProperty('padding-inline', '16px', 'important');
      widget.style.setProperty('box-sizing', 'border-box', 'important');
      widget.style.setProperty('overflow', 'hidden', 'important');

      widget.querySelectorAll('.fdt_widget_wrapper').forEach((node) => {
        node.style.setProperty('width', '100%', 'important');
        node.style.setProperty('max-width', '100%', 'important');
        node.style.setProperty('margin-left', '0', 'important');
        node.style.setProperty('margin-right', '0', 'important');
        node.style.setProperty('padding-inline', '0', 'important');
        node.style.setProperty('box-sizing', 'border-box', 'important');
        node.style.setProperty('overflow-x', 'hidden', 'important');
        node.style.setProperty('overflow-y', 'hidden', 'important');
      });

      widget.querySelectorAll('.fdt_carousel, .fdt_carousel__screen, .fdt_reviews, .fdt_rev_block, .fdt_carousel__track').forEach((node) => {
        node.style.setProperty('width', '100%', 'important');
        node.style.setProperty('max-width', '100%', 'important');
        node.style.setProperty('margin-inline', 'auto', 'important');
        if (node.classList.contains('fdt_carousel__track')) {
          node.style.setProperty('gap', '6px', 'important');
          node.style.setProperty('padding-inline', '0', 'important');
        }
        node.style.setProperty('overflow-x', node.classList.contains('fdt_carousel__track') ? 'auto' : 'hidden', 'important');
        node.style.setProperty('overflow-y', 'hidden', 'important');
      });

      widget.querySelectorAll('.fdt_carousel__item').forEach((item) => {
        item.style.setProperty('flex', '0 0 calc(100% - 6px)', 'important');
        item.style.setProperty('width', 'calc(100% - 6px)', 'important');
        item.style.setProperty('max-width', 'none', 'important');
      });
    });
  };

  const patchFeedatySection = (section) => {
    if (!section || !section.querySelector('.shopify-feedaty-widget')) return false;

    patchFeedatyVerifiedIcon(section);
    patchFeedatyDesktopArrows(section);
    patchFeedatyMobileWidth(section);
    return true;
  };

  const scheduleFeedatyPatch = (() => {
    let scheduled = false;

    return (section) => {
      if (!section || scheduled) return;

      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        patchFeedatySection(section);
      });
    };
  })();

  const disconnectFeedatyObservers = () => {
    if (feedatyVisibilityObserver) {
      feedatyVisibilityObserver.disconnect();
      feedatyVisibilityObserver = null;
    }

    if (feedatyMutationObserver) {
      feedatyMutationObserver.disconnect();
      feedatyMutationObserver = null;
    }
  };

  const ensureFeedatySectionObserver = (section) => {
    if (!section || activeFeedatySection === section) return;

    if (feedatyMutationObserver) {
      feedatyMutationObserver.disconnect();
    }

    activeFeedatySection = section;
    feedatyMutationObserver = new MutationObserver(() => scheduleFeedatyPatch(section));
    feedatyMutationObserver.observe(section, {
      childList: true,
      subtree: true,
    });
  };

  const bootFeedaty = () => {
    const section = document.querySelector(FEEDATY_SECTION_SELECTOR);
    if (!section) return;

    const activate = () => {
      FEEDATY_PATCH_DELAYS.forEach((delay) => {
        setTimeout(() => scheduleFeedatyPatch(section), delay);
      });
      ensureFeedatySectionObserver(section);
    };

    if ('IntersectionObserver' in window) {
      if (feedatyVisibilityObserver) return;

      feedatyVisibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          activate();
          disconnectFeedatyObservers();
          ensureFeedatySectionObserver(section);
        });
      }, {
        rootMargin: '300px 0px',
      });

      feedatyVisibilityObserver.observe(section);
      return;
    }

    activate();
  };

  const scheduleFeedatyOnResize = debounce(() => {
    const section = document.querySelector(FEEDATY_SECTION_SELECTOR);
    if (section) {
      scheduleFeedatyPatch(section);
    }
  }, 150);

  document.addEventListener('click', (event) => {
    const option = event.target instanceof Element ? event.target.closest('.cf-opt') : null;
    if (!option || option.disabled || option.classList.contains('is-hidden')) return;

    const panel = option.closest('[data-cf-panel]');
    const root = option.closest('[data-cf-root]');
    if (!panel || !root) return;

    const name = panel.getAttribute('data-cf-panel');
    if (!name) return;

    const value = option.getAttribute('data-cf-value') || '';
    const label = value ? option.textContent.trim() : option.textContent.trim();
    setFieldLabel(root, name, label);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cf-root]').forEach((root) => {
      Object.keys(DEFAULT_LABELS).forEach((name) => {
        const labelNode = root.querySelector(`[data-cf-label="${name}"]`);
        const current = labelNode?.textContent?.trim();
        const label = current && current !== DEFAULT_LABELS[name] ? current : '';
        setFieldLabel(root, name, label);
      });
    });

    patchHomeVideo();
    bootFeedaty();
  });

  window.addEventListener('load', () => {
    patchHomeVideo();
    bootFeedaty();
  }, { once: true });

  document.addEventListener('shopify:section:load', () => {
    patchHomeVideo();
    bootFeedaty();
  });

  if (!feedatyResizeBound) {
    window.addEventListener('resize', scheduleFeedatyOnResize, { passive: true });
    feedatyResizeBound = true;
  }
})();
